// extracted by mini-css-extract-plugin
export default {"main":"CompanyList_main__OuDYf","container":"CompanyList_container__9+hzM","switch":"CompanyList_switch__HtWeW font-sm-regular"};